import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [    
    {
        path: 'callback',                
        loadComponent: () =>  import('./features/dashboard/callback/callback.component').then(m => m.CallbackComponent)
    },
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard'
    },
    {
        path: 'dashboard',
        loadComponent: () =>  import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent),
        canActivate: [authGuard],
        canActivateChild: [authGuard],
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'profile'
            },
            {
                path: 'profile',
                loadComponent: () =>  import('./features/dashboard/profile/profile.component').then(m => m.ProfileComponent),
                children: [
                    {
                        path: '',
                        loadComponent: () => import('./features/dashboard/profile/user-profile/user-profile.component').then(m => m.UserProfileComponent),
                        data: {
                            breadcrumb: 'Profile',
                            pageName: 'My Profile'
                        },
                        title: 'Spark - My Profile'
                    },                    
                    {
                        path: 'reset-password',
                        loadComponent: () => import('./features/dashboard/profile/reset-password/reset-password.component').then(m => m.ResetPasswordComponent),
                        data: {
                            breadcrumb: 'Password',
                            pageName: 'My Profile'
                        },
                        title: 'Spark - Password'
                    },
                    {
                        path: 'mfa',
                        loadComponent: () => import('./features/dashboard/profile/mfa/mfa.component').then(m => m.MfaComponent),
                        data: {
                            breadcrumb: 'Multi Factor Authentication',
                            pageName: 'My Profile'
                        },
                        title: 'Spark - Multi Factor Authentication'
                    }
                ]
            }
        ]
    },
    {
        path: '**',
        redirectTo: 'dashboard'
    }
];
